import {
    GatewayFilterRequestResponse,
} from 'app/requests/Gateway/Gateway.types'
import {
    injectFieldsToTabs, RangeType,
    SkyNetTableConfig, SkyNetTableField,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    AddressCategory,
    GatewayDataPlan,
    GatewayHardwareVersion,
    GatewayStatus,
    GatewayType,
} from 'app/enums/label.enums'
import {
    convertFromFilterDaysDate,
    convertToFilterDaysDate,
    parseFromFilterDaysDate,
    parseToFilterDaysDate,
} from 'app/utils/date'

const fields: SkyNetTableField<keyof GatewayFilterRequestResponse>[] = [
    {
        name: 'gatewayType',
        componentName: 'EnumValue',
        allowedValuesEnum: GatewayType,
        filterField: 'gatewayType',
        filterType: FilterType.Array,
        reduced: true,
        width: '148px',
    },
    {
        name: 'gatewayImeiMac',
        width: '160px',
    },
    {
        name: 'gatewayStatus',
        componentName: 'EnumValue',
        allowedValuesEnum: GatewayStatus,
        filterField: 'gatewayStatus',
        filterType: FilterType.Array,
        width: '148px',
    },
    {
        name: 'lastStatusChangedOn',
        componentName: 'StatusAge',
        labelKey: 'ContainerView.containerStatusEnrichedChangedOnUtc',
        rangeType: RangeType.DayRange,
        filterField: 'lastStatusChangedOn',
        filterType: FilterType.IntegerRange,
        filterOptions: {
            labels: {
                from: 'More or Equal (Days)',
                to: 'Less Then (Days)',
            },
            convert: {
                from: convertFromFilterDaysDate,
                to: convertToFilterDaysDate,
            },
            parse: {
                from: parseFromFilterDaysDate,
                to: parseToFilterDaysDate,
            },
        },
        width: '148px',
    },
    {
        name: 'loggerConnections',
        width: '128px',
    },
    {
        name: 'isConnectedLora',
        componentName: 'CloudIconBoolean',
        filterField: 'isConnectedLora',
        filterType: FilterType.Array,
        width: '128px',
    },
    {
        name: 'lastConnectedOn',
        componentName: 'TemperatureAge',
        width: '148px',
    },
    {
        name: 'locationLocationName',
        reduced: true,
        filterField: 'locationLocationName',
        width: '380px',
        filterType: FilterType.Array,
    },
    {
        name: 'locationCountryName',
        labelKey: 'Gateway.locationCountry',
        filterField: 'locationCountryName',
        width: '180px',
        filterType: FilterType.Array,
    },
    {
        name: 'locationPortOfReferenceIataCode',
        labelKey: 'LocationView.portOfReference',
        filterField: 'locationPortOfReferenceIataCode',
        width: '180px',
        filterType: FilterType.Array,
    },
    {
        name: 'gatewayLocationCategories',
        componentName: 'EnumList',
        allowedValuesEnum: AddressCategory,
        width: '320px',
    },
    {
        name: 'area',
        filterField: 'area',
        filterType: FilterType.Array,
        width: '160px',
    },
    {
        name: 'gatewayDeploymentName',
        filterField: 'gatewayDeploymentName',
        labelKey: 'Deployment.deploymentName',
        filterType: FilterType.Array,
        width: '220px',
    },
    {
        name: 'hardwareVersion',
        filterField: 'hardwareVersion',
        filterType: FilterType.Array,
        componentName: 'EnumValue',
        allowedValuesEnum: GatewayHardwareVersion,
        labelKey: 'Gateway.hardwareVersion',
        width: '180px',
    },
    {
        name: 'gatewayConnectionType',
        filterField: 'gatewayConnectionType',
        filterType: FilterType.Array,
        componentName: 'EnumValue',
        allowedValuesEnum: GatewayDataPlan,
        width: '180px',
    },
    {
        name: 'remark',
        width: '380px',
    },
]

const config: SkyNetTableConfig<keyof GatewayFilterRequestResponse> = {
    name: 'GatewaysTable',
    tabs: injectFieldsToTabs<keyof GatewayFilterRequestResponse>([
        {
            name: 'Gateways',
            url: CommonRoutes.All,
        },
        {
            name: 'Excluded',
            url: CommonRoutes.Excluded,
        },
    ], fields),
}

export default config
